export interface EnquiryInput {
  artworkId: string;
  name: string;
  email: string;
  message: string;
}

export type EnquiryErrors = Partial<Record<keyof EnquiryInput, string>>;

export type EnquiryValidationResult =
  | { ok: true; value: EnquiryInput }
  | { ok: false; errors: EnquiryErrors };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEnquiry(input: EnquiryInput): EnquiryValidationResult {
  const value = {
    artworkId: input.artworkId.trim(),
    name: input.name.trim(),
    email: input.email.trim(),
    message: input.message.trim()
  };
  const errors: EnquiryErrors = {};

  if (!value.artworkId) errors.artworkId = "Choose an artwork first.";
  if (!value.name) errors.name = "Enter your name.";
  if (!EMAIL_RE.test(value.email)) errors.email = "Enter a valid email address.";
  if (value.message.length < 10) errors.message = "Enter a message of at least 10 characters.";

  if (Object.keys(errors).length > 0) {
    return { ok: false, errors };
  }

  return { ok: true, value };
}
